import React from 'react';
import { SalesAssistantDrawerWrapper } from './styles';
import { UtilitiesIconButton } from '../styles';
import { SalesAssistantIcon } from './SalesAssistantIcon';
import { ErrorBoundary } from 'src/commons/components/ErrorBoundary';
import { RootState } from 'src/app/store';
import { connect } from 'react-redux';
import {
  selectSalesAssistantLoading,
  selectUserInfoFromHeader,
  UserInfo,
} from '../../store/slice';
import { canShowSalesAssistant } from './salesAssistantUtils';

const takd_id = 'sales-assistant-atc';

interface SalesAssistantButtonProps {
  salesAssistantLoaded: boolean;
  userInfo: UserInfo;
}

const SalesAssistantButton: React.VFC<SalesAssistantButtonProps> = (props) => {
  const userEmail = props.userInfo?.customerInfo?.primaryEmail || '';

  if (!props.salesAssistantLoaded || !canShowSalesAssistant(userEmail)) {
    return null;
  }

  const salesAssistantIconEl = React.useRef<HTMLElement>(null);
  const maximizeSalesAssistant = () => {
    window.dispatchEvent(new CustomEvent('salesAssistantMaximize'));
  };

  return (
    <ErrorBoundary name="sales-assistant-button">
      <SalesAssistantDrawerWrapper ref={salesAssistantIconEl}>
        <UtilitiesIconButton
          className="sales-assistant-drawer-button"
          id={takd_id}
          data-takt-id={takd_id}
          onClick={maximizeSalesAssistant}
        >
          <SalesAssistantIcon aria-hidden="true" />
        </UtilitiesIconButton>
      </SalesAssistantDrawerWrapper>
    </ErrorBoundary>
  );
};

const SalesAssistantButtonConnector = connect((state: RootState) => {
  return {
    salesAssistantLoaded: selectSalesAssistantLoading(state),
    userInfo: selectUserInfoFromHeader(state),
  };
});

export const ConnectedSalesAssistantButton =
  SalesAssistantButtonConnector(SalesAssistantButton);
